import { Service, signal } from '@angular/core';

/** `quick-action:<row key>` is a side-menu ＋ panel. */
export type MainOverlay =
  | 'notifications'
  | 'profile'
  | `quick-action:${string}`
  | null;

@Service()
export class MainService {
  isSidebarCollapsed = signal<boolean>(false);
  /** True while an employee/admin layout renders the KUIP-68 side menu; app.component hides the navbar then. */
  sideMenuShown = signal<boolean>(false);
  /** The side-menu overlay that is open. Opening one closes the other. */
  openOverlay = signal<MainOverlay>(null);
}
